import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Input, Button, Space, Typography, message, Tag, Spin, Divider } from 'antd';
import { SaveOutlined, SafetyOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

const { Title, Text } = Typography;

function MeuPerfil() {
  const navigate = useNavigate();
  const [u, setU] = useState(null);
  const [salvando, setSalvando] = useState(false);
  const [previa, setPrevia] = useState(null);

  const set = (c, v) => setU((x) => ({ ...x, [c]: v }));

  const carregar = async () => {
    try {
      const r = await api.get('/usuarios/eu');
      setU(r.data);
    } catch { message.error('Não foi possível carregar o seu cadastro'); }
  };

  useEffect(() => { carregar(); }, []);

  const salvar = async () => {
    setSalvando(true);
    try {
      const r = await api.put('/usuarios/eu', {
        nome: u.nome, crea: u.crea, assinatura_texto: u.assinatura_texto,
        qualificacao_end: u.qualificacao_end, qualificacao_end_validade: u.qualificacao_end_validade || null,
      });
      setU(r.data);
      message.success('Perfil salvo');
    } catch (e) { message.error('Erro ao salvar: ' + (e.response?.data?.erro || e.message)); }
    finally { setSalvando(false); }
  };

  const enviarAssinatura = async (f) => {
    if (!f) return;
    const fd = new FormData();
    fd.append('arquivo', f);
    try {
      message.loading({ content: 'Enviando assinatura...', key: 'ass', duration: 0 });
      await api.post('/upload/assinatura/' + u.id, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      message.success({ content: 'Assinatura enviada', key: 'ass' });
      setPrevia(URL.createObjectURL(f));
      carregar();
    } catch (e) {
      message.error({ content: 'Erro ao enviar: ' + (e.response?.data?.erro || e.message), key: 'ass' });
    }
  };

  if (!u) return <div style={{ padding: 40, textAlign: 'center' }}><Spin /></div>;

  return (
    <div style={{ maxWidth: 820 }}>
      <Space style={{ marginBottom: 12 }}>
        <Title level={4} style={{ margin: 0 }}>Meu Perfil</Title>
        <Tag color="blue">{u.perfil}</Tag>
        {u.responsavel_tecnico && <Tag color="gold">responsável técnico</Tag>}
      </Space>

      <Card size="small" title="Dados" style={{ marginBottom: 12 }}>
        <Row gutter={10}>
          <Col span={12}><Text type="secondary">Nome completo</Text>
            <Input value={u.nome || ''} onChange={(e) => set('nome', e.target.value)} /></Col>
          <Col span={12}><Text type="secondary">E-mail</Text>
            <Input value={u.email || ''} disabled /></Col>
          <Col span={8} style={{ marginTop: 8 }}><Text type="secondary">CREA</Text>
            <Input value={u.crea || ''} onChange={(e) => set('crea', e.target.value)} placeholder="Ex: 045266MG" /></Col>
        </Row>
      </Card>

      <Card size="small" title="Qualificação em ensaios não destrutivos" style={{ marginBottom: 12 }}>
        <Row gutter={10}>
          <Col span={14}><Text type="secondary">Certificação</Text>
            <Input value={u.qualificacao_end || ''} onChange={(e) => set('qualificacao_end', e.target.value)}
              placeholder="ABENDI SNQC LP N2 nº 12345" /></Col>
          <Col span={8}><Text type="secondary">Validade</Text>
            <Input type="date" value={u.qualificacao_end_validade || ''}
              onChange={(e) => set('qualificacao_end_validade', e.target.value)} /></Col>
        </Row>
        <Text type="secondary" style={{ fontSize: 12, display: 'block', marginTop: 8 }}>
          Sai no laudo de ensaio não destrutivo, embaixo do seu nome como inspetor.
        </Text>
      </Card>

      <Card size="small" title="Assinatura" style={{ marginBottom: 12 }}>
        <Row gutter={10}>
          <Col span={12}>
            <Text type="secondary">Imagem</Text>
            <div style={{ marginTop: 4 }}>
              <input type="file" accept="image/*" onChange={(e) => enviarAssinatura(e.target.files && e.target.files[0])} />
            </div>
            <Text type="secondary" style={{ fontSize: 12, display: 'block', marginTop: 6 }}>
              {u.assinatura_chave ? 'Já existe uma imagem enviada. Enviar outra substitui.' : 'Ainda sem imagem. PNG com fundo transparente fica melhor.'}
            </Text>
            {previa && <div style={{ marginTop: 8 }}><img src={previa} alt="assinatura" style={{ maxHeight: 70 }} /></div>}
          </Col>
          <Col span={12}>
            <Text type="secondary">Texto abaixo da assinatura</Text>
            <Input value={u.assinatura_texto || ''} onChange={(e) => set('assinatura_texto', e.target.value)}
              placeholder="Ex: Inspetor de END" />
            <Text type="secondary" style={{ fontSize: 12, display: 'block', marginTop: 6 }}>
              Aparece embaixo da linha da assinatura, no laudo.
            </Text>
          </Col>
        </Row>
        <Divider style={{ margin: '12px 0' }} />
        <Text type="secondary" style={{ fontSize: 12 }}>
          Esta assinatura vale para os laudos novos de ensaio não destrutivo. Os laudos de inspeção já configurados
          continuam usando a assinatura antiga do sistema.
        </Text>
      </Card>

      <Space>
        <Button type="primary" icon={<SaveOutlined />} loading={salvando} onClick={salvar}>Salvar</Button>
        <Button icon={<SafetyOutlined />} onClick={() => navigate('/seguranca')}>Segurança da conta</Button>
      </Space>
    </div>
  );
}

export default MeuPerfil;
